import { makeStyles } from '@material-ui/core/styles';
export const useLoggedInStyle = makeStyles(theme => ({
    body: {
        height: '100%',
        background: '#f6f7fd',
        overflow: 'auto',
    },

    boxx: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0.60)',
        backdropFilter: 'blur(12px)',
        color: theme.palette.primary.sunset,
        fontSize: '28px',
        fontFamily: theme.typography.body3Medium.fontFamily,
        // fontWeight: '700',
        fontStyle: 'normal',
        lineHeight: '36px',
        zIndex: '10',
        position: 'absolute',
        paddingTop: '7px',
        top: '2%',
        [theme.breakpoints.down('xs')]: {
            // paddingTop: '40px',
            // paddingTop: '45%',
            // top: '8%',
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            // paddingTop: '40px',
            // top: '10%',
        },
    },
    innerBoxx: {
        margin: 'auto',
    },
    wereloading: {
        color: '#F5EBDA',
        fontFamily: theme.typography.body3.fontFamily,
        marginBottom: '46px',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '31px',
            fontSize: theme.typography.h6.fontSize,
            lineHeight: '32px',
            fontWeight: 300,
        },
        '@media(min-width:600px) and (max-width:1019px)': {
            marginBottom: '34px',
        },
    },

    greeting: {
        color: '#F5EBDA',
        fontFamily: theme.typography.h5.fontFamily,
        marginTop: '14px',
        [theme.breakpoints.down('xs')]: {
            marginTop: '22px',
            fontSize: '24.6px !important',
            lineHeight: '32.6px !important',
        },
        '@media(min-width:600px) and (max-width:1019px)': {},
    },
}));
